import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex position-relative w-100 h-100 align-items-center justify-content-start",
  style: {"background-color":"rgba(255, 255, 255, 0.5)"}
}
const _hoisted_3 = { class: "d-block w-100 text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-success",
  role: "status"
}, null, -1)
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = {
  key: 1,
  class: "col-12"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = {
  key: 0,
  class: "col-12 alert-warning p-3"
}
const _hoisted_11 = {
  key: 0,
  class: "col-12 alert-warning p-3"
}
const _hoisted_12 = {
  key: 1,
  class: "col-lg-7"
}
const _hoisted_13 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.loading.text), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", null, [
            (_ctx.conAccesoVip === undefined || _ctx.getters.tipoActividad.toString() !== 'recital')
              ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.t('reserva.diaHorario')), 1))
              : (_ctx.conAccesoVip === true)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.t('reserva.diaHorario')) + " | VIP exclusivo", 1))
                : (_ctx.conAccesoVip === false)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_9, _toDisplayString(_ctx.t('reserva.diaHorario')) + " | Campo general", 1))
                  : _createCommentVNode("", true)
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.t('reserve.errorDispon')), 1)
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.days.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.t('reserve.notTurnDisp')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("select", {
                        class: "input my-3",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dayValue) = $event)),
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: day.id,
                            value: day.id
                          }, _toDisplayString(day.concatenado), 9, _hoisted_13))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.dayValue]
                      ])
                    ]))
              ], 64))
        ]))
  ]))
}